/*
 *###############################################################################
 *Module Name                   : ProductGroup.js                               #
 *Purpose of the Module         :                                               #
 *Description of the Module     :                                               #
 *Original Author               :  W M Shanika Chamodi                          #
 *Date                          : Friday, September 10th 2021, 1:39:43 pm       #
 *Copyright © 2021 myPOS Software Solution (pvt Ltd.)                           #
 *###############################################################################
 */

import React, { useEffect, useState } from "react"
import { Row, Col, Button } from "reactstrap"
import DPTextBoxforgrid from "../../../framework/components/DPTextBoxforgrid"
import DPSearchBoxDynamic from "framework/components/DPSearchBoxDynamic"
import ReactPaginate from "react-paginate"
import { Text } from "framework/validators/TextValidation"

const ProductGroupContent = ({ DataRow, Disabled, menuCode, AddNew, GroupsDisable, setoptionGroup1, handleClearStatus }) => {

  const [postsPerPage] = useState(10)
  const [currentPage, setCurrentPage] = useState(1)

  /*
  * @description This function is used to reset the page number to 1 when the clear button is clicked.
  */
  useEffect(() => {
    setCurrentPage(1)
  }, [handleClearStatus])
  /**
      * @description This function is used to change the value of perticular field in perticular row.
      * @param {string} value - value of the row.
      * @param {string} id - id of the row.
      * @param {string} element - element of the row.
   */

  const changeRowValueChanges = (value, id, element) => {
    const objectIndex = DataRow.findIndex(obj => obj.code === id);
    const newObject = { ...DataRow[objectIndex], [element]: value };
    setoptionGroup1(prevDataRow => {
      const newDataRow = [...prevDataRow];
      newDataRow[objectIndex] = newObject;
      return newDataRow;
    });
  };

  /**
      * @description This function is used to change the value of complete row.
      * @param {JSON} row - row of the table.
      * @param {string} id - id of the row.
   */

  function handleObjectChange(row, id) {
    const objectIndex = DataRow.findIndex(obj => obj.code === id);
    setoptionGroup1(prevDataRow => {
      const newDataRow = [...prevDataRow];
      newDataRow[objectIndex] = row;
      return newDataRow;
    });
  }

  const handlePageClick = (event) => {
    setCurrentPage(event.selected + 1);
  };


  const indexOfLastPost = currentPage * postsPerPage
  const indexOfFirstPost = indexOfLastPost - postsPerPage
  const currentPosts = DataRow.slice(indexOfFirstPost, indexOfLastPost)


  return (
    <React.Fragment>
      <Row>
        <Col sm={12} md={12} className="mb-12-sm">
          <table style={{ fontSize: "11px" }} id={"GroupDet"}>
            <thead className="table-light">
              <tr>
                <th>No </th>
                <th>Name </th>
                <th>Code </th>
                <th></th>
                <th>Description </th>
              </tr>
            </thead>
            <tbody>
              {/* {(DataRow || []).map((DataRow, key) => {
                var disableValue = Disabled ? true : GroupsDisable.includes(DataRow.code) ? true : Disabled

                if (DataRow.code != null) {
                  return <TableRow FormRow={DataRow} Key={key} Disabled={disableValue} menuCode={menuCode} AddNew={AddNew} GroupsDisable={GroupsDisable} changeRowValueChanges={changeRowValueChanges} handleObjectChange={handleObjectChange} />
                }

              })} */}

              {/* *********************** */}


              {(DataRow || []).map((DataRow, key) => {
                var Disabled = Disabled ? true : GroupsDisable.includes(DataRow.code) ? true : Disabled
              })}

              {(currentPosts).map((formRow, key) => (
                <TableRow FormRow={formRow}
                  Key={key}
                  DataRow={DataRow}
                  Disabled={Disabled}
                  GroupsDisable={GroupsDisable}
                  menuCode={menuCode}
                  changeRowValueChanges={changeRowValueChanges}
                  handleObjectChange={handleObjectChange}
                  AddNew={AddNew}
                />
              ))}

              {/**********************/}

            </tbody>
          </table>
        </Col>
        <Row>
          <Col md="12">
            <div style={{ marginTop: '15px' }}>
              <ReactPaginate
                previousLabel={'Previous'}
                nextLabel={'Next'}
                breakLabel={'...'}
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakClassName="page-item"
                breakLinkClassName="page-link"
                pageCount={Math.ceil(DataRow.length / postsPerPage)}
                pageRangeDisplayed={5}
                onPageChange={handlePageClick}
                forcePage={currentPage - 1}
                renderOnZeroPageCount={null}
                activeClassName={'active'}
                activeLinkClassName={'page-link'}
                containerClassName={'pagination justify-content-center pagination-sm'}
              />
            </div>
          </Col>
        </Row>
      </Row>
    </React.Fragment>
  )
}
export default ProductGroupContent
const ApiURL = window.Links.ApiURL

const TableRow = ({ FormRow, Key, Disabled, menuCode, AddNew, GroupsDisable, changeRowValueChanges, handleObjectChange }) => {


  const [modal_xlarge, setmodal_xlarge] = useState(false)
  const [groupFilter, SetGroupFilter] = useState('a')

  //default sorted method
  const defaultSorted = [
    {
      dataField: "id",
      order: "asc",
    },
  ]
  //********************************************/

  const Hed_SelectRowSearch = (e, row, isSelect, rowIndex) => {

    var currentRow = FormRow
    currentRow.groupCode = row.GP_CODE
    currentRow.groupName = row.GP_DESC
    handleObjectChange(currentRow, FormRow.code)
    setmodal_xlarge(!modal_xlarge)
  }

  async function GroupSearch(value) {
    const currentRow = FormRow;

    // Clear group fields and update state
    const clearGroupFields = () => {
      currentRow.groupCode = "";
      currentRow.groupName = "";
      handleObjectChange(currentRow, currentRow.code);
    };

    if (!value) {
      clearGroupFields();
      return;
    }

    const authToken = localStorage.getItem("authToken");
    const ApiURL = window.Links.ApiURL;

    try {
      const response = await fetch(`${ApiURL}GroupSetup/GroupSelect`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${authToken}`,
        },
        body: JSON.stringify({
          groupNo: currentRow.code,
          groupCode: value
        }),
      });

      if (!response.ok) {
        // You can handle specific status codes here if needed
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const responseData = await response.json();

      if (responseData.success && responseData.data?.length) {
        const group = responseData.data[0];
        currentRow.groupCode = group.code;
        currentRow.groupName = group.name;
      } else {
        clearGroupFields();
        return;
      }

      handleObjectChange(currentRow, currentRow.code);
    } catch (error) {
      console.error("GroupSearch error:", error);
      clearGroupFields();
    }
  }



  function tog_xlarge() {
    setmodal_xlarge(!modal_xlarge)
    removeBodyCss()
  }
  async function clickSearch() {
    tog_xlarge()
  }

  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }


  //* End Code Validation   */
  return (
    <tr key={FormRow.id}>
      <td style={{ width: "100px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              disabled={true}
              id={"txtCode" + Key}
              value={FormRow.code}

            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "200px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              disabled={true}
              id={"txtdesc" + Key}
              value={FormRow.name}
              onChange={e => {
                //setdesc(e.target.value)
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "100px" }}>
        <Row className="mb-0">
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              maxLength="8"
              disabled={Disabled}
              id={"txtGroupcode" + Key}
              value={FormRow.groupCode}
              onChange={e => {
                //setGroupcode(e.target.value)

                let valStockCode = Text(
                  e.target,
                  25,
                  true,
                  true,
                  "any",
                  true
                )

                changeRowValueChanges(valStockCode, FormRow.code, "groupCode")

              }}
              onBlur={e => {
                GroupSearch(e.target.value)
              }}
              onKeyPress={e => {
                if (e.key === 'Enter') {
                  if (e.target.value == "") {
                    GroupSearch("NA")
                  } else {
                    GroupSearch(e.target.value)
                  }
                }
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>
      <td style={{ width: "30px" }}>
        <Row className="mb-0" >
          <Col md="3">
            <Button
              outline
              disabled={Disabled}
              color="success"
              id={"btnGroupSearch" + Key}
              onClick={clickSearch}
              size="sm"
            >
              <i
                className="mdi mdi-search-web"
                style={{ fontSize: "12px" }}
              ></i>
            </Button>
          </Col>
        </Row>
      </td>

      <td style={{ width: "400px" }}>
        <Row className="mb-0" >
          <Col md="12">
            <DPTextBoxforgrid
              rowClass="mb-12-sm"
              labelText="Code"
              textType="text"
              disabled={true}
              id={"txtGroupdesc" + Key}
              value={FormRow.groupName}
              onChange={e => {
                changeRowValueChanges(e.target.value, FormRow.code, "groupName")
              }}
            ></DPTextBoxforgrid>
          </Col>
        </Row>
      </td>

      <td>
        <Row className="mb-0">
          <DPSearchBoxDynamic
            searchData={[]}
            columns={[]}
            defaultSorted={defaultSorted}
            mainTitle={FormRow.name + " Search"}
            SelectType={"radio"} //checkbox for multipe, radio for single, ROW_SELECT_DISABLED for disable
            isOpen={modal_xlarge}
            toggle={tog_xlarge}
            getSelect={Hed_SelectRowSearch}
            APIURL={ApiURL}
            URLPath={"PRODUCT" + FormRow.code}
            MenuCode={menuCode}
            KeyVal={'GRP' + FormRow.code}
            searchBy={'GP_CODE'}
            FilterStr={groupFilter}
          />
        </Row>
      </td>
    </tr>
  )
}
